import { i18n } from 'src/boot/i18n'
import { Dialog } from 'quasar'
import component from 'components/modals/Dialog.vue'

export default async function (options) {
  const props = Object.assign({
    btnRight: i18n.t('label.ok').toString()
  }, options)
  return new Promise((resolve, reject) => {
    const dialog = Dialog.create({
      component,
      ...props
    }).onOk(action => {
      resolve()
      dialog.hide()
    })
  })
}
